import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        target: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2 ng-if="!vm.form.model.id">{{ 'licence.Add target' | translate }}</h2>
            <h2 ng-if="vm.form.model.id">{{ 'licence.Edit target' | translate}}</h2>
        </div>
        <div class="modal-body">
            <div class="form">
                <manage-settings-licences-periods-form form="vm.form"/>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.createFromResource(this.target);
    }

    save () {
        this.form.save().then(() => this.uibModalInstance.close());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/manage/licences/edit/targets/index.js